module.exports = __webpack_public_path__ + "static/media/vatomator_framed.ae3395ac.png";